import { InjectionToken, Type } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FieldConfig } from '../models/field-config.model';

// contrato que cada componente de campo debe implementar
export interface FieldComponent {
  field: FieldConfig;
  control: FormControl;
  /** FormGroup completo del formulario. Se inyecta para permitir
   *  que campos especiales (ej: fecha de nacimiento) actualicen
   *  otros controles hermanos. */
  form?: FormGroup;
}

// mapa tipo → componente
export interface FieldRegistryMap {
  [fieldType: string]: Type<FieldComponent>;
}

// token de inyección
export const FIELD_REGISTRY =
  new InjectionToken<FieldRegistryMap>('FIELD_REGISTRY');